import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';
import { signInAuthProvider } from 'auth';
import clsx from 'clsx';

// fileStatus: selected, inprogress, uploaded
class FileChip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
    };
  }

  handleDelete = (id) => {
    const { onDelete } = this.props;
    if (!id) {
      return; // selected file, no id in cloud yet.
    }
    this.setState({ deleting: true }, () => {
      // TODO: delete file failed
      console.log('try deleting file..', id);
      onDelete && onDelete(id);
    });
  };

  renderExistingFile = (file) => {
    return (
      <Chip
        label={file.fileName}
        onDelete={() => this.handleDelete(file.id)}
        deleteIcon={this.state.deleting ? <CircularProgress size={20} /> : <DeleteForeverIcon />}
      />
    );
  };

  renderNewFileDeleteIcon = (fileObj) => {
    const { percentComplete, file, status, error } = fileObj;
    if (status === 'failed') {
      return (
        <Tooltip
          placement="top-start"
          title={error || 'update failed'}
        >
          <ErrorIcon />
        </Tooltip>
      );
    } else if (percentComplete < 1) {
      return <CircularProgress size={20} variant="determinate" value={percentComplete * 100} />;
    } else {
      return <DeleteForever />;
    }
  };

  renderNewFile = (fileObj) => {
    // once upload completed, id will be fetched as part of file
    const { id } = this.props;
    const { percentComplete, file } = fileObj;
    return (
      <Chip
        label={file.name}
        onDelete={() => this.handleDelete(id)}
        deleteIcon={this.renderNewFileDeleteIcon(fileObj)}
      />
    );
  };

  render() {
    const { file, fileObj } = this.props;
    if (file) {
      return this.renderExistingFile(file);
    } else {
      return this.renderNewFile(fileObj);
    }
  }
}

FileChip.propTypes = {
  fileStatus: PropTypes.string,
  file: PropTypes.object,
  onDeleteFile: PropTypes.func,
};

export default FileChip;
